export const baseUrl = '/help-center'
